import { message } from "antd";
import LayoutEnum from "./layoutEnum";

const hardcodeToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI1OTc0ZmI4Zi0wZTZmLTQwNTAtYmMzOS1iOGU5OWI3NmNjZTEiLCJuYW1lIjoiQWJ1IEJha2FyIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiOTFkZDJlMi1mNDEwLTRkYjgtOWVmNC0zMjNmOTFhOGU1NDIuanBnIiwiZW1haWwiOiJhYnViYWthckBtaWxldGFwLmNvbSIsImJ1c2luZXNzSWQiOiIwYWI1ZjljMC1mOTQ4LTRjNDAtOGRhZC1jNThiYTk5ZmI3NjUiLCJ2ZXIiOiI3RkY0QjI2NC01NjY3LTQ1MkEtOUVEOS1GNEY0NTE4N0ZDMkEiLCJpaCI6ImtZRGw5ckRDME1oeTZSVGFrS0lQbWRBUlVlWjR3ek5HckJBVVNlOURJTTQ9IiwiaXMiOiIwamovREp3UWQ3THB4dVo3cDdkanlnPT0iLCJwaCI6IlErV0lXSHNkU204RE4xR1JXbkljM29DWTRabDZmc1BSOElLeVRJRC9HdU09IiwicHMiOiIrZXVaQU1rOTl4RE5DOG1xNXZPUFpRPT0iLCJwbGF0Zm9ybSI6IldlYiIsImlzQWdlbnQiOiJGYWxzZSIsImp0aSI6ImQyN2NkYTQwLWRjYTYtNDczNy1hMzZkLTRhODkyYjNlOGY3ZCIsIm5iZiI6MTc3NjUwMjMxNywiZXhwIjoxNzc2Njc1MTE3fQ.LAI3VsBJPVy51Y25ZDWobj6C37zBTfZ0sJHtyE6PuzD7ZJENxtGF0RHTmNWY9zVjhFDiUBkVhVy0J1G-QEiiKjGiEa7Ub81iksPcxSiPss5A_VeX24gaL7rWVDBHW15c1o_KtDMsVp0F6j0__FVk_JiPqU4mTuRdRd3nU5Vk9OboT4pmCuLuj_seX9_8YFQzKLP2mfQuIgtVYBE_XkruOWoIIyVPLlEY76nxcUXd1nsNZihncMdUd9Ideap-8RmPFJDhr4w_cny-c8DUjfNx1Ev_xChIPvMrf0GWJUoomTHTA3NVGdFxuP7CAp7SQITehCArBoPS-vGqKoz0jdF67g";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token")
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || hardcodeToken;
  return finalToken;
}

export function decodeWorkWiseToken() {
  const token = getWorkWiseAuthToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export const isStyleChanged = (existingStyle, masterStyle) => {
  for (const styleKey of Object.keys(existingStyle)) {
    let existingKeySlice = typeof existingStyle[styleKey] === 'string' ? existingStyle[styleKey].substring(0, 5) : null;
    let masterKeySlice = typeof masterStyle[styleKey] === 'string' ? masterStyle[styleKey].substring(0, 5) : null;

    if (existingKeySlice !== null && masterKeySlice !== null) {
      if (existingKeySlice !== masterKeySlice) {
        // console.log('Slice Key (Master):', styleKey, 'Substring:', existingKeySlice, masterKeySlice);
        return true;
      }
    } else if (!isNaN(parseFloat(existingStyle[styleKey]))) {
      const existingNumValue = parseFloat(existingStyle[styleKey]).toFixed(3);
      const masterNumValue = isNaN(parseFloat(existingStyle[styleKey])) ?
        parseFloat(masterStyle[styleKey]).toFixed(3) : null;
      if (masterNumValue && existingNumValue !== masterNumValue) {
        // console.log('Slice Key (Master - Number):', styleKey, 'Value:', existingNumValue, masterNumValue);
        return true;
      }
    }
  }
  return false;
};

export const modifyMasterSlideData = (masterSlideData) => {

  if (!masterSlideData) {
    return null;
  }

  let modifiedTextBoxes = {};
  let filteredTextBoxIds = masterSlideData.textBoxIds.filter((id) => !id.includes('master'));
  for (const textBoxId of filteredTextBoxIds) {
    modifiedTextBoxes[textBoxId] = {
      ...masterSlideData.textBox[textBoxId],
      styles: { ...masterSlideData.textBox[textBoxId].styles, pointerEvents: 'none' },
    };
  }

  let modifiedShapes = {};
  for (const shapeId of Object.keys(masterSlideData.shapes)) {
    modifiedShapes[shapeId] = {
      ...masterSlideData.shapes[shapeId],
      styles: { ...masterSlideData.shapes[shapeId].styles, pointerEvents: 'none' },
    };
  }

  let modifiedImages = {};
  for (const imgId of masterSlideData.imageIds) {
    if (masterSlideData.image[imgId]) {
      modifiedImages[imgId] = {
        ...masterSlideData.image[imgId],
        styles: { ...masterSlideData.image[imgId].styles, pointerEvents: 'none' },
      };
    }
  }
  let modifiedMasterSlideData = {
    slideBackgroundColor: masterSlideData.slideBackgroundColor,
    textBoxIds: filteredTextBoxIds,
    textBox: modifiedTextBoxes,
    imageIds: [...masterSlideData.imageIds],
    image: modifiedImages,
    shapes: modifiedShapes,
    speakerNotes: masterSlideData.speakerNotes,
  };
  return modifiedMasterSlideData;
}

export const removeDuplicates = (slideData, masterSlideData) => {

  const newSlideData = {
    ...slideData,
    textBoxIds: slideData.textBoxIds.filter(id => !masterSlideData.textBoxIds.includes(id)),
    imageIds: slideData.imageIds.filter(id => !masterSlideData.imageIds.includes(id)),
    shapes: {},
    image: {},
    textBox: {}
  };


  // Add textBoxes to newSlideData
  Object.keys(slideData.textBox).forEach(textBoxId => {
    if (!masterSlideData.textBox[textBoxId]) {
      newSlideData.textBox[textBoxId] = slideData.textBox[textBoxId];
    }
  });

  // Add shapes to newSlideData
  Object.keys(slideData.shapes).forEach(shapeId => {
    if (!masterSlideData.shapes[shapeId]) {
      newSlideData.shapes[shapeId] = slideData.shapes[shapeId];
    }
  });

  // Add images to newSlideData
  Object.keys(slideData.image).forEach(imgId => {
    if (!masterSlideData.image[imgId]) {
      newSlideData.image[imgId] = slideData.image[imgId];
    }
  });
  return newSlideData;
};

export const getUpdatedSlides = (elementData, type, existingSlides) => {
  const currentSlideId = elementData.currentSlideId;
  const currentSlide = existingSlides[currentSlideId];

  switch (type) {
    case 'text': {
      const textId = elementData.textId;
      const updatedTextboxIds = [...currentSlide.textBoxIds, textId];
      const updatedTextboxes = {
        ...currentSlide.textBox,
        [textId]: {
          delta: elementData.delta ? elementData.delta : { ops: [{ insert: '' }] },
          styles: elementData.style,
        },
      };
      return {
        ...existingSlides,
        [currentSlideId]: {
          ...currentSlide,
          textBox: updatedTextboxes,
          textBoxIds: updatedTextboxIds,
        },
      };
    }
    case 'image': {
      const imageId = elementData.imageId;
      const imageb64 = elementData.imageb64;
      const style = elementData.style;
      const updatedImageIds = [...currentSlide.imageIds, imageId];
      const updatedImages = { ...currentSlide.image, [imageId]: { imageb64, styles: style } };
      return {
        ...existingSlides,
        [currentSlideId]: {
          ...currentSlide,
          image: updatedImages,
          imageIds: updatedImageIds,
        },
      };
    }
    case 'shape': {
      const shapeId = elementData.shapeId;
      const updatedShapes = {
        ...currentSlide.shapes,
        [shapeId]: {
          delta: elementData.delta ? elementData.delta : { ops: [{ insert: '' }] },
          styles: elementData.style,
        },
      };
      return {
        ...existingSlides,
        [currentSlideId]: {
          ...currentSlide,
          shapes: updatedShapes,
        },
      };
    }
    case 'slide': {
      const { slideId, slideData } = elementData;
      return {
        ...existingSlides,
        [slideId]: slideData,
      };
    }
    case 'backgroundColor': {
      const { slideId, backgroundColor } = elementData;
      return {
        ...existingSlides,
        [slideId]: {
          ...existingSlides[slideId],
          slideBackgroundColor: backgroundColor,
        },
      };
    }
    case 'speakerNotes': {
      const { slideId, content } = elementData;
      return {
        ...existingSlides,
        [slideId]: {
          ...existingSlides[slideId],
          speakerNotes: content,
        },
      };
    }
    default:
      return existingSlides;
  }
};
export const updateTextboxDelta = (existingSlides, elementData, type) => {
  const { currentSlideId, textBoxId, shapeId, content } = elementData;

  switch (type) {
    case 'textbox': {
      const currentTextBox = existingSlides[currentSlideId]?.textBox?.[textBoxId];
      if (!currentTextBox) {
        throw new Error(`TextBox with ID ${textBoxId} not found in slide ${currentSlideId}`);
      }
      const updatedTextBox = { ...currentTextBox, delta: content };
      return {
        ...existingSlides,
        [currentSlideId]: {
          ...existingSlides[currentSlideId],
          textBox: {
            ...existingSlides[currentSlideId].textBox,
            [textBoxId]: updatedTextBox,
          },
        },
      };
    }
    case 'shape': {
      const currentShape = existingSlides[currentSlideId]?.shapes?.[shapeId];
      if (!currentShape) {
        throw new Error(`Shape with ID ${shapeId} not found in slide ${currentSlideId}`);
      }
      const updatedShape = { ...currentShape, delta: content };
      return {
        ...existingSlides,
        [currentSlideId]: {
          ...existingSlides[currentSlideId],
          shapes: {
            ...existingSlides[currentSlideId].shapes,
            [shapeId]: updatedShape,
          },
        },
      };
    }
    default:
      throw new Error(`Unknown type: ${type}`);
  }
};
export const updateElementStyle = (existingSlides, elementData, type) => {
  const { currentSlideId, textBoxId, updatedStyle } = elementData;
  let updatedSlides;

  switch (type) {
    case 'text': {
      const updatedTextBox = {
        ...existingSlides[currentSlideId].textBox[textBoxId],
        styles: updatedStyle,
      };
      updatedSlides = {
        ...existingSlides,
        [currentSlideId]: {
          ...existingSlides[currentSlideId],
          textBox: {
            ...existingSlides[currentSlideId].textBox,
            [textBoxId]: updatedTextBox,
          },
        },
      };
      break;
    }
    case 'image': {
      const updatedImage = {
        ...existingSlides[currentSlideId].image[textBoxId],
        styles: updatedStyle,
      };
      updatedSlides = {
        ...existingSlides,
        [currentSlideId]: {
          ...existingSlides[currentSlideId],
          image: {
            ...existingSlides[currentSlideId].image,
            [textBoxId]: updatedImage,
          },
        },
      };
      break;
    }
    case 'shape': {
      const updatedShape = {
        ...existingSlides[currentSlideId].shapes[textBoxId],
        styles: updatedStyle,
      };
      updatedSlides = {
        ...existingSlides,
        [currentSlideId]: {
          ...existingSlides[currentSlideId],
          shapes: {
            ...existingSlides[currentSlideId].shapes,
            [textBoxId]: updatedShape,
          },
        },
      };
      break;
    }
    default:
      throw new Error(`Unknown type: ${type}`);
  }

  return updatedSlides;
};

export const deleteElement = (existingSlides, elementData, type) => {
  const { slideId, elementId } = elementData;
  const updatedSlides = JSON.parse(JSON.stringify(existingSlides)); // Deep copy to avoid mutation

  switch (type) {
    case 'textbox': {
      updatedSlides[slideId].textBoxIds = updatedSlides[slideId].textBoxIds.filter(textBox => textBox !== elementId);
      delete updatedSlides[slideId].textBox[elementId];
      break;
    }
    case 'image': {
      updatedSlides[slideId].imageIds = updatedSlides[slideId].imageIds.filter(image => image !== elementId);
      delete updatedSlides[slideId].image[elementId];
      break;
    }
    case 'shape': {
      delete updatedSlides[slideId].shapes[elementId];
      break;
    }
    case 'slide': {
      const slideKeys = Object.keys(updatedSlides);
      const slideIndex = slideKeys.indexOf(slideId);
      const nextIndex = slideIndex === slideKeys.length - 1 ? slideIndex - 1 : slideIndex + 1;
      if (updatedSlides.currentSlideId === slideId) {
        updatedSlides.currentSlideId = slideKeys[nextIndex] ? slideKeys[nextIndex] : "";
      }
      delete updatedSlides[slideId];
      break;
    }
    default:
      throw new Error(`Unknown type: ${type}`);
  }

  return updatedSlides;
};
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};
export const filterOtherLayoutElements = (slideData, type) => {

  if (!slideData) return slideData;
  const layoutType = type.split('-')[1];
  const newSlideData = {
    ...slideData,
    textBoxIds: [],
    textBox: {},
    imageIds: [],
    image: {},
    shapes: {},
  };
  // Helper function to check if an element is of any layout type except the current one
  const isOtherLayoutElement = (id) => {
    const result = Object.values(LayoutEnum).some(layoutValue => {
      const layout = layoutValue.split('-')[1];
      const isDifferentLayout = layout.toLocaleLowerCase() !== layoutType.toLowerCase();
      const isIncludedInId = id.toLowerCase().includes(layout.toLowerCase());
      return isDifferentLayout && isIncludedInId;
    });
    return result;
  };

  // Filter textBoxIds and populate textBox
  newSlideData.textBoxIds = slideData.textBoxIds.filter(id => {
    if (!isOtherLayoutElement(id)) {
      newSlideData.textBox[id] = slideData.textBox[id];
      return true;
    }
    return false;
  });

  // Filter imageIds and populate image
  newSlideData.imageIds = slideData.imageIds.filter(id => {
    if (!isOtherLayoutElement(id)) {
      newSlideData.image[id] = slideData.image[id];
      return true;
    }
    return false;
  });

  // Add shapes to newSlideData
  Object.keys(slideData.shapes).forEach(shapeId => {
    if (!isOtherLayoutElement(shapeId)) {
      newSlideData.shapes[shapeId] = slideData.shapes[shapeId];
    }
  });
  return newSlideData;
};

export const getWatermarkData = async () => {
  const now = new Date();
  const currentDateTime = now.toLocaleString();

  // Get IP address
  let ip = 'N/A';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    message.error("Could not fetch IP address");
  }

  // Get location
  let location = { lat: 'N/A', lng: 'N/A' };
  try {
    location = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        message.error("Geolocation not supported");
        return resolve(location);
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }),
        (error) => {
          handleGeolocationError(error);
          resolve(location); // Return default on error
        }
      );
    });
  } catch (error) {
    console.error("Location error:", error);
  }

  return {
    currentDateTime,
    ip,
    location
  };
};

const handleGeolocationError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message.error("Location access denied. Please enable permissions.");
      break;
    case error.POSITION_UNAVAILABLE:
      message.error("Location information unavailable.");
      break;
    case error.TIMEOUT:
      message.error("Location request timed out.");
      break;
    default:
      message.error("Unknown location error occurred.");
  }
};

// Helper functions:

export async function checkClipboardForPasteableData() {
  // Method 1: Modern async clipboard API
  if (navigator.clipboard?.readText) {
    try {
      const text = await navigator.clipboard.readText();
      if (text) return true;
    } catch { } // Ignore permission errors in this check
  }

  // Method 2: Legacy clipboard access
  if (window.clipboardData?.getData) {
    return !!window.clipboardData.getData('text');
  }

  // Method 3: Check for image support
  if (navigator.clipboard?.read) {
    try {
      const items = await navigator.clipboard.read();
      return items.some(item =>
        item.types.some(type =>
          type.startsWith('image/') ||
          type === 'text/plain'
        )
      );
    } catch { } // Ignore permission errors
  }

  return false;
}

export const convertBlobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // The result contains the Base64 string
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const findParentWithIdKeyword = (ref, keyword, maxDepth = 5) => {
  if (!ref?.current) return null;

  let currentElement = ref.current;
  let depth = 0;

  while (currentElement && depth < maxDepth) {
    if (currentElement.id && currentElement.id.includes(keyword)) {
      return currentElement;
    }
    currentElement = currentElement.parentElement;
    depth++;
  }

  return null;
};

export const findElementType = (element) => {

  if (!element) {
    return null;
  }
  let current = element;

  while (current) {
    const id = current.id?.toLowerCase() || '';

    if (id.includes('shape')) return 'shape';
    if (id.includes('image')) return 'image';
    if (id.includes('text')) return 'text';

    current = current.parentElement;
  }

  return null;
};

export const processTemplateData = (serverResponse) => {
  let templateData = serverResponse?.data?.data || null;
  if (templateData?.milepadData) {
    try {
      const rawData = JSON.parse(templateData.milepadData);
      delete templateData.milepadData;
      templateData.slideData = rawData;
    } catch (error) {
      console.error('Failed to parse template milepadData:', error);
      delete templateData.milepadData;
      templateData.slideData = {};
    }
  }
  return templateData;
};

export const removeTemplateIdFromURL = (history) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('templateId');
  const newSearch = searchParams.toString();
  history.replace({
    pathname: window.location.pathname,
    search: newSearch ? `?${newSearch}` : ''
  });
};